import { connect } from 'react-redux';
import AppleIdVerify from './AppleIdVerify';
import { getUserAfterAppleId } from '../../components/login/login_actions';

const mDTP = { getUserAfterAppleId };

export default connect(null, mDTP)(AppleIdVerify);
